import { Component, OnDestroy } from "@angular/core";

@Component({
    templateUrl: './unauthorized.component.html'
})
export class UnAuthorizedComponent  {
    
}


// WEBPACK FOOTER //
// ./src/app/components/unauthorized/unauthorized.component.ts